/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockFastIcon16Regular = forwardRef('TimeClockFastIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2.875 6A5.502 5.502 0 0 1 13.5 8 5.5 5.5 0 0 1 8 13.5V15a7 7 0 1 0-6.71-9h1.585Z" }),
        React.createElement("path", { d: "M7.75 3.949a.75.75 0 0 1 .75.75v2.674a.25.25 0 0 0 .141.225l2.134 1.035a.75.75 0 1 1-.654 1.35L7.987 8.948A1.75 1.75 0 0 1 7 7.373V4.7a.75.75 0 0 1 .75-.75Z" }),
        React.createElement("path", { d: "M.781 7.25a.75.75 0 0 0 0 1.5h1.875a.75.75 0 0 0 0-1.5H.781Z" }),
        React.createElement("path", { d: "M.031 11a.75.75 0 0 1 .75-.75H4.5a.75.75 0 0 1 0 1.5H.781a.75.75 0 0 1-.75-.75Z" }),
        React.createElement("path", { d: "M1 13.25a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5H1Z" })));
});
